import React from "react";
import { Typography, tokens } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import type { DesignPreferenceItemFormatted } from "../../types/designPreferences";

type DesignPreferenceOutputTextProps = {
  item: DesignPreferenceItemFormatted;
  renderAsHyperlink: boolean;
};

const DesignPreferenceOutputText: React.FC<DesignPreferenceOutputTextProps> = ({
  item,
  renderAsHyperlink,
}) => {
  const { question, response, relatedURL } = item;

  if (relatedURL && renderAsHyperlink) {
    return (
      <HyperlinkText
        href={relatedURL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {question}
      </HyperlinkText>
    );
  }

  if (relatedURL && !renderAsHyperlink) {
    return (
      <Typography size={tokens.FONT_SIZE_0} color={tokens.TINTS_OFF_WHITE_20}>
        {question}&nbsp;
        <RelatedUrlLink
          href={relatedURL}
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </RelatedUrlLink>
      </Typography>
    );
  }

  return (
    <InfoField>
      <Typography color={tokens.TINTS_OFF_WHITE_20}>{question}</Typography>
      {response && <Typography>{response}</Typography>}
    </InfoField>
  );
};

const InfoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const HyperlinkText = styled.a`
  color: ${tokens.BRAND_HEROBLUE};
  text-decoration: underline;
  cursor: pointer;
  font-size: ${tokens.FONT_SIZE_1}px;
  line-height: ${tokens.LINE_HEIGHTS_12}px;

  &:hover {
    opacity: 0.8;
  }
`;

const RelatedUrlLink = styled.a`
  color: ${tokens.TINTS_OFF_WHITE_20};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export { DesignPreferenceOutputText };
